
import axios from "../api/axiosInstance";


export const login =async (username , password) => {
    return await axios.get("/Auth/login", {
        UserName: username,
        PasswordHash: password,
      });
};
export const changePassword = async (newPassword) => {
  return await axios.post(
    `/Auth/ChangePassword?newPassword=${encodeURIComponent(newPassword)}`
  );
};
export const changeUserPassword = async (userId, newPassword) => {
    return await axios.post(
        `/Auth/ChangeUserPassword?userId=${userId}&newPassword=${encodeURIComponent(newPassword)}`
    );
};
export const ChangeLanguage = async (model) => {
    return await axios.post("/Auth/ChangeLanguage", model);
};
